const fr = {
  meta: { title: "IndusHub Afrique — Expertise industrielle & numérique à la demande" },
  common: {
    select: "Sélectionner…",
    example: "Exemple",
    perHour: "€ / h",
    loading: "Chargement…",
    optional: "facultatif",
    required: "obligatoire",
  },
  verticals: { agro: "Agroalimentaire", mines: "Mines", petrole: "Pétrole & Gaz", numerique: "Numérique & Technologies" },
  verticalsShort: { agro: "Agro", mines: "Mines", petrole: "Pétrole & Gaz", numerique: "Numérique" },
  needs: {
    emergency: "Assistance d'urgence (télé-maintenance)",
    audit: "Audit sur site",
    pool: "Pool d'experts / arrêt technique",
    sourcing: "Achat & livraison de machines",
    training: "Formation — Académie IndusHub",
  },
  urgencies: { blocking: "Bloquant — production à l'arrêt", urgent: "Urgent — sous 48h", planned: "Planifié — pas de délai critique" },
  availability: { immediate: "Immédiate", "48h": "Sous 48h", "7d": "Sous 7 jours" },
  statuses: { new: "Nouvelle", in_progress: "En cours", resolved: "Résolue", closed: "Clôturée", running: "En cours", completed: "Facturée" },
  errors: {
    required: "Ce champ est obligatoire.",
    min: (n) => `${n} caractères minimum.`,
    email: "Adresse e-mail invalide.",
    phone: "Numéro invalide (chiffres, espaces, + ( ) - . uniquement).",
    rate: "Taux horaire entre 20 et 1000 €.",
    pickVertical: "Choisissez au moins un vertical.",
    skills: "Indiquez au moins une compétence.",
    expert: "Sélectionnez un expert du pool.",
    duplicate: "Un profil expert existe déjà pour cet e-mail.",
    generic: "Une erreur est survenue. Veuillez réessayer.",
    fixErrors: "Veuillez corriger les champs signalés.",
    intl: "Format international requis, ex. +225 07 00 00 00 00.",
    optinPhone: "Un numéro au format international est requis pour WhatsApp.",
    password: "8 caractères minimum.",
    mismatch: "Les mots de passe ne correspondent pas.",
    participantsErr: "Entre 1 et 500 participants.",
  },
  nav: {
    links: [["verticaux", "Verticaux"], ["services", "Services"], ["academie", "Académie"], ["garanties", "Garanties"], ["espace", "Espace pro"], ["reseau", "Réseau"]],
    cta: "Demander un diagnostic",
    menu: "Menu",
    switchTo: "Switch to English",
  },
  hero: {
    eyebrow: "Plateforme B2B — Maintenance industrielle & numérique",
    titleA: "L'expert français, ",
    titleHi: "à un ticket vidéo",
    titleB: " de votre panne.",
    lead: "IndusHub Afrique connecte vos sites agroalimentaires, miniers, pétroliers et numériques d'Afrique francophone au pool d'experts en maintenance et en technologies basés en France et en Europe — pour diagnostiquer à distance ou auditer sur place, dépanner, sécuriser vos systèmes, former vos équipes et sourcer l'équipement dont vous avez besoin.",
    cta1: "Demander un diagnostic",
    cta2: "Voir les services",
    meta: [["4", "verticaux métiers couverts"], ["12", "pays d'implantation"], ["< 30 min", "délai moyen de mise en relation"]],
    consoleTitle: "Poste de supervision — Interventions",
    live: "En direct",
    tickets: "tickets",
    ticker: [
      ["Ticket #2291 résolu — ", "poste frigorifique", ", Abidjan — 14 min"],
      ["Expert projeté — ", "hydraulique convoyeur", ", Boké — arrêt technique"],
      ["Ticket #2288 résolu — ", "instrumentation plateforme", ", Port-Gentil — 22 min"],
      ["Session formation — ", "consignation LOTO", ", Dakar — 14 cadres certifiés"],
      ["Ticket #2295 résolu — ", "durcissement SOC", ", Abidjan — 31 min"],
      ["Expert projeté — ", "migration cloud souverain", ", Dakar — arrêt de production évité"],
    ],
    stats: [
      ["live", "Experts qualifiés dans le pool — en direct"],
      ["5 services", "De l'assistance d'urgence à la formation des équipes"],
      ["2 continents", "Un hub reliant l'Europe et l'Afrique francophone"],
      ["4 secteurs", "Agroalimentaire, mines, pétrole & gaz, numérique"],
    ],
  },
  partners: {
    head: "Ils soutiennent IndusHub Afrique",
    slot: "Emplacement partenaire",
    slots: ["Assurance RC Pro", "Prestataire de paiement", "École d'ingénieurs", "Chambre de commerce", "Fédération industrielle", "Cabinet juridique", "Association professionnelle", "Organisme de certification"],
  },
  figures: {
    eyebrow: "Chiffres clés",
    items: [
      ["live", "experts qualifiés dans le pool — en direct"],
      ["24 h", "pour recontacter chaque demande de diagnostic"],
      ["< 300 000", "professionnels certifiés en cybersécurité pour tout le continent"],
      ["< 1 %", "de la capacité mondiale des data centers hébergée en Afrique"],
    ],
  },
  verticalsSection: {
    eyebrow: "A — Verticaux métiers",
    title: "Quatre secteurs. Quatre cahiers des charges.",
    desc: "Chaque vertical a ses pannes types, son vocabulaire technique et ses normes. IndusHub route chaque ticket vers l'expert qualifié pour le bon métier — pas un généraliste. Depuis la version 2.1, le hub couvre aussi le numérique, un domaine où l'Afrique manque cruellement d'experts qualifiés : cybersécurité, cloud souverain et intelligence artificielle appliquée.",
    cards: {
      agro: { sub: "Côte d'Ivoire · Sénégal · Cameroun · Bénin · Togo", items: ["Optimisation des lignes de conditionnement", "Maintenance des systèmes frigorifiques", "Chaînes de transformation cacao, café, céréales"], tags: ["Froid industriel", "Conditionnement"], badge: "Modèle d'audit agroalimentaire — sur demande" },
      mines: { sub: "Guinée · Mali · Burkina Faso", items: ["Maintenance des engins lourds (extracteurs, convoyeurs)", "Hydraulique industrielle", "Traitement des minerais"], tags: ["Hydraulique", "Engins lourds"], badge: "Modèle d'audit mines — sur demande" },
      petrole: { sub: "Gabon · Congo · Sénégal", items: ["Maintenance préventive des plateformes", "Instrumentation, tuyauterie haute pression", "Conformité et sécurité strictes"], tags: ["HSE", "Haute pression"], badge: "Modèle d'audit pétrole & gaz — sur demande" },
      numerique: { sub: "Sénégal · Côte d'Ivoire · Cameroun · Maroc · Rwanda", items: ["Cybersécurité & SOC — durcissement, réponse à incident", "Cloud, data centers & souveraineté des données", "IA appliquée (agriculture, santé, finance) & automatisation"], tags: ["Cybersécurité", "Cloud & IA"], badge: "Modèle d'audit numérique — sur demande" },
    },
    footnote: "Ce vertical répond à un déficit documenté : moins de 300 000 professionnels certifiés en cybersécurité pour tout le continent, moins de 1 % de la capacité mondiale des centres de données hébergée en Afrique, et une dépendance structurelle aux technologies conçues ailleurs. IndusHub y projette des experts capables d'auditer, de sécuriser et de transférer la compétence sur place.",
  },
  services: {
    eyebrow: "B — Services proposés",
    title: "De l'urgence à la montée en compétences",
    desc: "Cinq façons d'accéder à l'expertise, selon l'intensité du besoin — d'un simple ticket vidéo à l'achat et la livraison d'un équipement neuf sur site.",
    cards: [
      { num: "Service 01 — Temps réel", title: "Assistance d'urgence", desc: "Visioconférence sécurisée : un expert en France guide par ticket vidéo un technicien sur site pour diagnostiquer une panne bloquante.", flow: ["Le technicien ouvre un ticket vidéo", "L'expert qualifié est connecté en direct", "Diagnostic et remise en service guidés"] },
      { num: "Service 02 — Sur place", title: "Audit sur site", desc: "Quand le diagnostic à distance ne suffit pas, un ingénieur est projeté sur votre site pour un audit complet des installations et des équipements.", flow: ["Cadrage du périmètre à auditer", "Signature du contrat de mission", "Ingénieur projeté sur site en Afrique", "Rapport d'état et plan d'action remis"], badge: ["4 modèles d'audit — un par pôle d'activité", "#verticaux"] },
      { num: "Service 03 — Courtage", title: "Pool d'experts", desc: "Base de données qualifiée d'ingénieurs et techniciens seniors — dont des retraités de l'industrie française — projetés sur site pour les arrêts techniques.", flow: ["Diplômes et références vérifiés", "Mise en relation selon le vertical", "Signature du contrat de mission", "Projection sur site pour l'arrêt technique"], badge: ["Contrat de mission type — voir Conformité", "#garanties"] },
      { num: "Service 04 — Sourcing", title: "Achat & livraison de machines", desc: "IndusHub sert d'intermédiaire pour l'achat d'équipements industriels auprès de fournisseurs européens, jusqu'à leur livraison et mise en service sur site en Afrique.", flow: ["Sourcing auprès de fournisseurs qualifiés", "Négociation et suivi de la commande", "Livraison et mise en service sur site"], badge: ["RC Pro internationale & garantie fournisseur — voir Conformité", "#garanties"] },
      { num: "Service 05 — Formation", title: "L'Académie IndusHub", desc: "Modules de formation aux normes de sécurité internationales pour faire monter en compétences les cadres et équipes locales.", flow: ["Sélection du module par vertical", "Session délivrée à distance ou sur site", "Certification des équipes locales"] },
    ],
  },
  process: {
    eyebrow: "Parcours client",
    title: "Du signalement à la panne résolue",
    steps: [
      ["Signaler", "Le site industriel ouvre un ticket décrivant la panne ou le besoin d'arrêt technique."],
      ["Router", "IndusHub identifie l'expert, l'auditeur ou le fournisseur qualifié selon le vertical et le besoin."],
      ["Connecter", "Visio sécurisée ou projection de l'expert sur site selon l'urgence."],
      ["Résoudre", "Diagnostic, remise en service et rapport d'intervention transmis au client."],
    ],
  },
  guarantees: {
    eyebrow: "Sécurité juridique & conformité",
    title: "Le sourcing d'équipement, sous contrôle",
    desc: "Faire transiter une machine entre un fournisseur européen et un site en Afrique engage une responsabilité différente du simple courtage de compétences. IndusHub encadre chaque étape pour sécuriser le fournisseur, le transport et le client final.",
    cards: [
      { title: "Assurance RC Pro internationale", desc: "Couvre les risques de pertes d'exploitation liés à une intervention d'expert ou à un équipement livré non conforme sur site." },
      { title: "Contrats de sous-traitance internationaux", desc: "Un contrat type encadre chaque relation : mission signée par l'expert ou le technicien avant intervention, convention de service signée par l'entreprise cliente à la souscription.", badges: ["Contrat de mission — expert/technicien (sur demande)", "Contrat de service — entreprise cliente (sur demande)"] },
      { title: "Douane, transport & garantie fournisseur", desc: "Suivi de la livraison jusqu'au site et activation de la garantie fournisseur en cas de défaut constaté à réception." },
    ],
  },
  pro: {
    eyebrow: "Espace pro",
    title: "Le hub, de la mise en relation à la facturation.",
    desc: "Trois briques opérationnelles : un moteur de correspondance qui route chaque demande vers l'expert le plus pertinent, un espace pour les coordonnées des deux parties, et un horodateur qui déclenche la facturation dès le début de l'intervention.",
    tabs: { matching: "Moteur de correspondance", client: "Espace client (usine)", expert: "Espace expert", timer: "Horodateur & facturation" },
    matching: {
      intro: "Le moteur applique une règle de correspondance transparente sur le pool d'experts réellement inscrits : vertical (40 pts), compétences recherchées (35), disponibilité selon l'urgence (15) et note (10).",
      vertical: "Vertical concerné",
      urgency: "Urgence",
      skills: "Compétences recherchées (séparées par une virgule)",
      skillsPh: "ex : froid industriel, hydraulique, instrumentation",
      note: "Le classement se recalcule à chaque recherche",
      submit: "Trouver un expert",
      searching: "Recherche…",
      count: (n, p) => `${n} correspondance${n > 1 ? "s" : ""} sur ${p} experts du pool`,
      none: "Aucun expert ne correspond à ce besoin pour le moment.",
      matched: "Compétences correspondantes",
      breakdown: { vertical: "Vertical", skills: "Compétences", availability: "Dispo.", rating: "Note" },
      avail: "dispo.",
      launch: "Lancer une intervention",
    },
    client: {
      intro: "Mettez à jour le profil de votre entreprise et suivez vos demandes de diagnostic, vos interventions et vos factures — visibles uniquement par votre compte.",
      profileTitle: "Profil entreprise",
      company: "Raison sociale",
      email: "E-mail professionnel",
      contact: "Nom du contact",
      vertical: "Vertical",
      site: "Site / usine",
      country: "Pays",
      phone: "Téléphone",
      submit: "Enregistrer le profil client",
      saved: (c) => `Profil enregistré pour ${c}.`,
      payNote: "Le prélèvement de l'abonnement sera configuré via un prestataire de paiement certifié — aucune coordonnée bancaire n'est stockée sur la plateforme.",
      lookupTitle: "Mes demandes & interventions",
      lookupLabel: "E-mail utilisé lors de vos demandes",
      lookupBtn: "Consulter",
      noProfile: "Aucun profil entreprise enregistré pour cet e-mail.",
      requests: "Demandes de diagnostic",
      interventions: "Interventions",
      noRequests: "Aucune demande trouvée pour cet e-mail.",
      noInterventions: "Aucune intervention pour cet e-mail.",
      headers: { ref: "Réf.", date: "Date", need: "Besoin", urgency: "Urgence", status: "Statut", expert: "Expert", duration: "Durée", amount: "Montant HT", invoice: "Facture" },
    },
    expert: {
      intro: "Inscrivez votre profil : il rejoint immédiatement le pool interrogé par le moteur de correspondance et devient sélectionnable dans l'horodateur.",
      name: "Nom et prénom",
      email: "E-mail",
      country: "Pays de résidence",
      verticals: "Verticaux d'intervention",
      skills: "Compétences (séparées par une virgule)",
      skillsPh: "ex : hydraulique, engins lourds, convoyeurs",
      rate: "Taux horaire (€ HT)",
      availability: "Disponibilité",
      note: "Rejoindre le pool visible par le moteur de correspondance",
      submit: "Rejoindre le pool d'experts",
      saved: (n) => `Profil enregistré. ${n}, vous êtes désormais visible dans le pool utilisé par le moteur de correspondance.`,
      payNote: "Le virement des missions passera par un prestataire de paiement certifié — jamais par un stockage direct de coordonnées bancaires sur la plateforme.",
    },
    timer: {
      title: "Horodateur d'intervention — facturation automatique",
      waiting: "En attente de connexion expert ↔ site",
      running: "Intervention en cours — connecté au site",
      closed: (r) => `Intervention clôturée — facture générée (${r})`,
      engaged: "HT engagés",
      expert: "Expert connecté",
      expertPh: "Sélectionner un expert du pool…",
      rate: "Taux horaire appliqué",
      company: "Entreprise cliente",
      email: "E-mail client",
      site: "Site en production",
      sitePh: "ex : Usine de Yamoussoukro",
      commission: "Commission IndusHub",
      start: "Démarrer l'intervention",
      stop: "Terminer et facturer",
      note: "Le chronomètre démarre dès la connexion expert ↔ site et enregistre une ligne de facturation à la clôture. Le coût est calculé côté serveur à partir du taux horaire de l'expert.",
      ledger: "Historique des interventions facturées",
      ledgerHint: "Historique associé à l'e-mail client saisi.",
      empty: "Aucune intervention facturée pour le moment.",
      headers: ["Réf.", "Expert", "Site", "Durée", "Montant HT", "Commission", "Net expert", "PDF"],
      download: "Télécharger la facture PDF",
      siteNA: "Site non renseigné",
    },
  },
  network: {
    eyebrow: "Réseau",
    title: "Un hub, deux continents",
    desc: "Le pool d'experts basés en France et en Europe rayonne vers douze implantations en Afrique francophone, réparties sur les quatre verticaux.",
    aria: "Schéma du réseau IndusHub reliant le pool d'experts en Europe aux sites en Afrique francophone",
    countries: { togo: "Togo", ci: "Côte d'Ivoire", sn: "Sénégal", cm: "Cameroun", bj: "Bénin", gn: "Guinée", ml: "Mali", bf: "Burkina Faso", ga: "Gabon", cg: "Congo", ma: "Maroc", rw: "Rwanda" },
  },
  contact: {
    eyebrow: "Prochaine étape",
    title: "Fiche de demande de diagnostic",
    desc: "Décrivez votre site et votre besoin — diagnostic à distance, audit sur site, arrêt technique, sourcing d'équipement ou plan de formation. Un membre d'IndusHub vous recontacte sous 24h.",
    ticket: "Ticket d'intervention — Nouvelle demande",
    secure: "Formulaire sécurisé",
    company: "Entreprise / site", companyPh: "ex. Cimenterie de Boké",
    country: "Pays", countryPh: "ex. Guinée",
    vertical: "Vertical",
    need: "Type de besoin",
    urgency: "Niveau d'urgence",
    contact: "Nom du contact", contactPh: "Nom et fonction",
    email: "E-mail professionnel", emailPh: "nom@entreprise.com",
    phone: "Téléphone", phonePh: "+225 …",
    desc2: "Description de la panne ou du besoin", descPh: "Symptômes, équipement concerné, historique de la panne…",
    note: "transmis chiffré à l'équipe de routage",
    submit: "Envoyer la demande",
    sending: "Envoi…",
    created: "créé",
    confirm: (d, v) => [`Demande `, d.need, ` enregistrée pour `, d.company, ` (${v} — ${d.country}). Un expert qualifié vous recontacte à `, d.email, ` sous 24h — plus rapidement si le niveau d'urgence l'exige.`],
    reset: "Nouvelle demande",
    expertQ: "Vous êtes expert ou technicien ?",
    expertLink: "Rejoignez le pool d'experts",
    companyQ: "Vous êtes une entreprise ?",
    companyLink: "Créez votre espace client",
  },
  footer: {
    copy: "© 2026 IndusHub Afrique — Courtage & maintenance industrielle",
    legal: "Mentions légales & confidentialité",
    legalTitle: "Mentions légales & confidentialité",
    legalBody: "IndusHub Afrique — plateforme B2B de courtage et de maintenance industrielle. Les données transmises via les formulaires (demandes de diagnostic, profils client et expert, interventions) sont utilisées uniquement pour la mise en relation et la facturation des missions. Aucune coordonnée bancaire n'est collectée sur ce site. Pour toute demande d'accès ou de suppression de vos données, contactez l'équipe IndusHub via la fiche de demande.",
    admin: "Administration",
  },
  admin: {
    loginTitle: "Console d'administration",
    loginSub: "Accès réservé à l'équipe IndusHub",
    email: "E-mail",
    password: "Mot de passe",
    submit: "Se connecter",
    invalid: "E-mail ou mot de passe incorrect.",
    back: "Retour au site",
    logout: "Déconnexion",
    title: "Tableau de bord",
    tabs: { requests: "Demandes de diagnostic", experts: "Experts", interventions: "Interventions" },
    stats: { diagnostics: "Demandes", new: "Nouvelles", experts: "Experts", examples: "dont exemples", interventions: "Interventions", revenue: "CA HT facturé", commission: "Commissions" },
    emailOn: "Notifications e-mail actives (ADMIN_NOTIFY_EMAIL).",
    emailOff: "ADMIN_NOTIFY_EMAIL non configuré — les demandes sont enregistrées, l'envoi d'e-mail est ignoré.",
    h: { ref: "Réf.", date: "Date", company: "Entreprise", contact: "Contact", vertical: "Vertical", need: "Besoin", urgency: "Urgence", status: "Statut", email: "E-mail notif.", name: "Nom", country: "Pays", skills: "Compétences", rate: "Taux", availability: "Dispo.", example: "Exemple", actions: "Actions", expert: "Expert", client: "Client", duration: "Durée", amount: "Montant HT", commission: "Commission", pdf: "PDF" },
    emailStatus: { pending: "en attente", sent: "envoyé", failed: "échec", skipped_no_recipient: "ignoré" },
    del: "Supprimer",
    confirmDel: (n) => `Supprimer définitivement l'expert ${n} ?`,
    deleted: "Expert supprimé.",
    updated: "Mise à jour enregistrée.",
    empty: "Aucun élément pour le moment.",
    view: "Détail",
  },
};

const en = {
  meta: { title: "IndusHub Afrique — Industrial & digital expertise on demand" },
  common: { select: "Select…", example: "Example", perHour: "€ / h", loading: "Loading…", optional: "optional", required: "required" },
  verticals: { agro: "Agri-food", mines: "Mining", petrole: "Oil & Gas", numerique: "Digital & Technology" },
  verticalsShort: { agro: "Agri-food", mines: "Mining", petrole: "Oil & Gas", numerique: "Digital" },
  needs: {
    emergency: "Emergency assistance (remote maintenance)",
    audit: "On-site audit",
    pool: "Expert pool / technical shutdown",
    sourcing: "Equipment purchase & delivery",
    training: "Training — IndusHub Academy",
  },
  urgencies: { blocking: "Blocking — production stopped", urgent: "Urgent — within 48h", planned: "Planned — no critical deadline" },
  availability: { immediate: "Immediate", "48h": "Within 48h", "7d": "Within 7 days" },
  statuses: { new: "New", in_progress: "In progress", resolved: "Resolved", closed: "Closed", running: "Running", completed: "Invoiced" },
  errors: {
    required: "This field is required.",
    min: (n) => `At least ${n} characters.`,
    email: "Invalid e-mail address.",
    phone: "Invalid number (digits, spaces, + ( ) - . only).",
    rate: "Hourly rate between €20 and €1000.",
    pickVertical: "Choose at least one vertical.",
    skills: "Enter at least one skill.",
    expert: "Select an expert from the pool.",
    duplicate: "An expert profile already exists for this e-mail.",
    generic: "Something went wrong. Please try again.",
    fixErrors: "Please fix the highlighted fields.",
    intl: "International format required, e.g. +225 07 00 00 00 00.",
    optinPhone: "A phone number in international format is required for WhatsApp.",
    password: "At least 8 characters.",
    mismatch: "Passwords do not match.",
    participantsErr: "Between 1 and 500 participants.",
  },
  nav: {
    links: [["verticaux", "Verticals"], ["services", "Services"], ["academie", "Academy"], ["garanties", "Guarantees"], ["espace", "Pro space"], ["reseau", "Network"]],
    cta: "Request a diagnostic",
    menu: "Menu",
    switchTo: "Passer en français",
  },
  hero: {
    eyebrow: "B2B platform — Industrial & digital maintenance",
    titleA: "The right expert, ",
    titleHi: "one video ticket",
    titleB: " away from your breakdown.",
    lead: "IndusHub Afrique connects your agri-food, mining, oil & gas and digital sites across French-speaking Africa to a pool of maintenance and technology experts based in France and Europe — for remote diagnostics or on-site audits, troubleshooting, securing your systems, training your teams and sourcing the equipment you need.",
    cta1: "Request a diagnostic",
    cta2: "See services",
    meta: [["4", "business verticals covered"], ["12", "countries of operation"], ["< 30 min", "average time to connect"]],
    consoleTitle: "Supervision desk — Interventions",
    live: "Live",
    tickets: "tickets",
    ticker: [
      ["Ticket #2291 resolved — ", "refrigeration unit", ", Abidjan — 14 min"],
      ["Expert dispatched — ", "conveyor hydraulics", ", Boké — planned shutdown"],
      ["Ticket #2288 resolved — ", "platform instrumentation", ", Port-Gentil — 22 min"],
      ["Training session — ", "LOTO lockout procedure", ", Dakar — 14 managers certified"],
      ["Ticket #2295 resolved — ", "SOC hardening", ", Abidjan — 31 min"],
      ["Expert dispatched — ", "sovereign cloud migration", ", Dakar — production outage avoided"],
    ],
    stats: [
      ["live", "Qualified experts in the pool — live"],
      ["5 services", "From emergency assistance to team training"],
      ["2 continents", "One hub linking Europe and French-speaking Africa"],
      ["4 sectors", "Agri-food, mining, oil & gas, digital"],
    ],
  },
  partners: {
    head: "They support IndusHub Afrique",
    slot: "Partner slot",
    slots: ["Professional liability insurer", "Payment provider", "Engineering school", "Chamber of commerce", "Industry federation", "Law firm", "Professional association", "Certification body"],
  },
  figures: {
    eyebrow: "Key figures",
    items: [
      ["live", "qualified experts in the pool — live"],
      ["24 h", "to get back to every diagnostic request"],
      ["< 300,000", "certified cybersecurity professionals for the whole continent"],
      ["< 1 %", "of the world's data center capacity hosted in Africa"],
    ],
  },
  verticalsSection: {
    eyebrow: "A — Business verticals",
    title: "Four sectors. Four scopes of work.",
    desc: "Each vertical has its own typical failures, technical vocabulary and standards. IndusHub routes every ticket to the expert qualified for the right trade — not a generalist. Since version 2.1, the hub also covers digital & technology, a field where Africa faces a critical shortage of qualified experts: cybersecurity, sovereign cloud and applied artificial intelligence.",
    cards: {
      agro: { sub: "Côte d'Ivoire · Senegal · Cameroon · Benin · Togo", items: ["Packaging line optimization", "Refrigeration system maintenance", "Cocoa, coffee and cereal processing chains"], tags: ["Industrial cold", "Packaging"], badge: "Agri-food audit template — on request" },
      mines: { sub: "Guinea · Mali · Burkina Faso", items: ["Heavy equipment maintenance (extractors, conveyors)", "Industrial hydraulics", "Ore processing"], tags: ["Hydraulics", "Heavy equipment"], badge: "Mining audit template — on request" },
      petrole: { sub: "Gabon · Congo · Senegal", items: ["Preventive maintenance of platforms", "Instrumentation, high-pressure piping", "Strict compliance and safety"], tags: ["HSE", "High pressure"], badge: "Oil & gas audit template — on request" },
      numerique: { sub: "Senegal · Côte d'Ivoire · Cameroon · Morocco · Rwanda", items: ["Cybersecurity & SOC — hardening, incident response", "Cloud, data centers & data sovereignty", "Applied AI (agriculture, health, finance) & automation"], tags: ["Cybersecurity", "Cloud & AI"], badge: "Digital audit template — on request" },
    },
    footnote: "This vertical addresses a documented gap: fewer than 300,000 certified cybersecurity professionals for the whole continent, less than 1% of the world's data center capacity hosted in Africa, and a structural dependence on technologies designed elsewhere. IndusHub deploys experts there able to audit, secure and transfer the skills on the ground.",
  },
  services: {
    eyebrow: "B — Services offered",
    title: "From emergencies to skills development",
    desc: "Five ways to access expertise, depending on the intensity of the need — from a simple video ticket to the purchase and delivery of new equipment on site.",
    cards: [
      { num: "Service 01 — Real time", title: "Emergency assistance", desc: "Secure video call: an expert in France guides an on-site technician via video ticket to diagnose a blocking failure.", flow: ["The technician opens a video ticket", "The qualified expert is connected live", "Guided diagnostic and restart"] },
      { num: "Service 02 — On site", title: "On-site audit", desc: "When remote diagnostics aren't enough, an engineer is dispatched to your site for a full audit of the facilities and equipment.", flow: ["Scoping of the audit perimeter", "Signing of the mission contract", "Engineer dispatched on site in Africa", "Status report and action plan delivered"], badge: ["4 audit templates — one per business unit", "#verticaux"] },
      { num: "Service 03 — Brokerage", title: "Expert pool", desc: "Qualified database of senior engineers and technicians — including retired French industry professionals — dispatched on site for technical shutdowns.", flow: ["Diplomas and references verified", "Matched according to the vertical", "Signing of the mission contract", "Dispatched on site for the technical shutdown"], badge: ["Standard mission contract — see Compliance", "#garanties"] },
      { num: "Service 04 — Sourcing", title: "Equipment purchase & delivery", desc: "IndusHub acts as an intermediary for purchasing industrial equipment from European suppliers, through to delivery and commissioning on site in Africa.", flow: ["Sourcing from qualified suppliers", "Order negotiation and follow-up", "Delivery and commissioning on site"], badge: ["International liability & supplier warranty — see Compliance", "#garanties"] },
      { num: "Service 05 — Training", title: "The IndusHub Academy", desc: "Training modules on international safety standards to upskill local managers and teams.", flow: ["Module selection by vertical", "Session delivered remotely or on site", "Certification of local teams"] },
    ],
  },
  process: {
    eyebrow: "Customer journey",
    title: "From reporting to resolved breakdown",
    steps: [
      ["Report", "The industrial site opens a ticket describing the breakdown or the need for a technical shutdown."],
      ["Route", "IndusHub identifies the qualified expert, auditor or supplier according to the vertical and the need."],
      ["Connect", "Secure video call or expert dispatched on site depending on urgency."],
      ["Resolve", "Diagnostic, restart and intervention report sent to the client."],
    ],
  },
  guarantees: {
    eyebrow: "Legal security & compliance",
    title: "Equipment sourcing, under control",
    desc: "Moving a machine between a European supplier and a site in Africa involves a different liability than simple skills brokerage. IndusHub oversees every step to protect the supplier, the transport and the end client.",
    cards: [
      { title: "International professional liability insurance", desc: "Covers operating loss risks linked to an expert intervention or to equipment delivered non-compliant on site." },
      { title: "International subcontracting contracts", desc: "A standard contract governs every relationship: a mission agreement signed by the expert or technician before the intervention, a service agreement signed by the client company upon subscription.", badges: ["Mission contract — expert/technician (on request)", "Service contract — client company (on request)"] },
      { title: "Customs, transport & supplier warranty", desc: "Delivery tracking to the site and activation of the supplier warranty in case of a defect found upon receipt." },
    ],
  },
  pro: {
    eyebrow: "Pro space",
    title: "The hub, from matching to invoicing.",
    desc: "Three operational building blocks: a matching engine that routes every request to the most relevant expert, a space for both parties' contact details, and a timer that triggers invoicing as soon as the intervention starts.",
    tabs: { matching: "Matching engine", client: "Client space (factory)", expert: "Expert space", timer: "Timer & invoicing" },
    matching: {
      intro: "The engine applies a transparent matching rule to the pool of actually registered experts: vertical (40 pts), requested skills (35), availability vs. urgency (15) and rating (10).",
      vertical: "Relevant vertical",
      urgency: "Urgency",
      skills: "Skills sought (comma-separated)",
      skillsPh: "e.g. industrial cold, hydraulics, instrumentation",
      note: "The ranking is recalculated with every search",
      submit: "Find an expert",
      searching: "Searching…",
      count: (n, p) => `${n} match${n > 1 ? "es" : ""} out of ${p} experts in the pool`,
      none: "No expert matches this need yet.",
      matched: "Matching skills",
      breakdown: { vertical: "Vertical", skills: "Skills", availability: "Avail.", rating: "Rating" },
      avail: "avail.",
      launch: "Start an intervention",
    },
    client: {
      intro: "Update your company profile and track your diagnostic requests, interventions and invoices — visible only to your account.",
      profileTitle: "Company profile",
      company: "Company name",
      email: "Professional e-mail",
      contact: "Contact name",
      vertical: "Vertical",
      site: "Site / factory",
      country: "Country",
      phone: "Phone",
      submit: "Save client profile",
      saved: (c) => `Profile saved for ${c}.`,
      payNote: "Subscription direct debit will be set up via a certified payment provider — no bank details are stored on the platform.",
      lookupTitle: "My requests & interventions",
      lookupLabel: "E-mail used for your requests",
      lookupBtn: "Look up",
      noProfile: "No company profile saved for this e-mail.",
      requests: "Diagnostic requests",
      interventions: "Interventions",
      noRequests: "No request found for this e-mail.",
      noInterventions: "No intervention for this e-mail.",
      headers: { ref: "Ref.", date: "Date", need: "Need", urgency: "Urgency", status: "Status", expert: "Expert", duration: "Duration", amount: "Amount excl. VAT", invoice: "Invoice" },
    },
    expert: {
      intro: "Register your profile: it immediately joins the pool queried by the matching engine and becomes selectable in the timer.",
      name: "Full name",
      email: "E-mail",
      country: "Country of residence",
      verticals: "Verticals covered",
      skills: "Skills (comma-separated)",
      skillsPh: "e.g. hydraulics, heavy equipment, conveyors",
      rate: "Hourly rate (€ excl. VAT)",
      availability: "Availability",
      note: "Join the pool visible to the matching engine",
      submit: "Join the expert pool",
      saved: (n) => `Profile saved. ${n}, you are now visible in the pool used by the matching engine.`,
      payNote: "Mission payments will go through a certified payment provider — never through direct storage of bank details on the platform.",
    },
    timer: {
      title: "Intervention timer — automatic invoicing",
      waiting: "Waiting for expert ↔ site connection",
      running: "Intervention in progress — connected to site",
      closed: (r) => `Intervention closed — invoice generated (${r})`,
      engaged: "excl. VAT committed",
      expert: "Connected expert",
      expertPh: "Select an expert from the pool…",
      rate: "Hourly rate applied",
      company: "Client company",
      email: "Client e-mail",
      site: "Production site",
      sitePh: "e.g. Yamoussoukro plant",
      commission: "IndusHub commission",
      start: "Start intervention",
      stop: "End and invoice",
      note: "The timer starts as soon as expert ↔ site are connected and records an invoice line at closure. The cost is computed server-side from the expert's hourly rate.",
      ledger: "History of invoiced interventions",
      ledgerHint: "History linked to the client e-mail entered.",
      empty: "No intervention invoiced yet.",
      headers: ["Ref.", "Expert", "Site", "Duration", "Amount excl. VAT", "Commission", "Net expert", "PDF"],
      download: "Download PDF invoice",
      siteNA: "Site not specified",
    },
  },
  network: {
    eyebrow: "Network",
    title: "One hub, two continents",
    desc: "The pool of experts based in France and Europe reaches out to twelve locations across French-speaking Africa, spread across the four verticals.",
    aria: "Diagram of the IndusHub network linking the expert pool in Europe to sites in French-speaking Africa",
    countries: { togo: "Togo", ci: "Côte d'Ivoire", sn: "Senegal", cm: "Cameroon", bj: "Benin", gn: "Guinea", ml: "Mali", bf: "Burkina Faso", ga: "Gabon", cg: "Congo", ma: "Morocco", rw: "Rwanda" },
  },
  contact: {
    eyebrow: "Next step",
    title: "Diagnostic request form",
    desc: "Describe your site and your need — remote diagnostic, on-site audit, technical shutdown, equipment sourcing or training plan. An IndusHub team member will contact you within 24h.",
    ticket: "Intervention ticket — New request",
    secure: "Secure form",
    company: "Company / site", companyPh: "e.g. Boké cement plant",
    country: "Country", countryPh: "e.g. Guinea",
    vertical: "Vertical",
    need: "Type of need",
    urgency: "Urgency level",
    contact: "Contact name", contactPh: "Name and role",
    email: "Professional e-mail", emailPh: "name@company.com",
    phone: "Phone", phonePh: "+225 …",
    desc2: "Description of the breakdown or need", descPh: "Symptoms, equipment concerned, breakdown history…",
    note: "sent encrypted to the routing team",
    submit: "Send request",
    sending: "Sending…",
    created: "created",
    confirm: (d, v) => [`Request `, d.need, ` registered for `, d.company, ` (${v} — ${d.country}). A qualified expert will contact you at `, d.email, ` within 24h — sooner if the urgency level requires it.`],
    reset: "New request",
    expertQ: "Are you an expert or technician?",
    expertLink: "Join the expert pool",
    companyQ: "Are you a company?",
    companyLink: "Create your client space",
  },
  footer: {
    copy: "© 2026 IndusHub Afrique — Industrial brokerage & maintenance",
    legal: "Legal notice & privacy",
    legalTitle: "Legal notice & privacy",
    legalBody: "IndusHub Afrique — B2B industrial brokerage and maintenance platform. Data submitted through the forms (diagnostic requests, client and expert profiles, interventions) is used solely for matching and invoicing missions. No bank details are collected on this site. For any request to access or delete your data, contact the IndusHub team via the request form.",
    admin: "Administration",
  },
  admin: {
    loginTitle: "Admin console",
    loginSub: "Restricted to the IndusHub team",
    email: "E-mail",
    password: "Password",
    submit: "Sign in",
    invalid: "Incorrect e-mail or password.",
    back: "Back to site",
    logout: "Sign out",
    title: "Dashboard",
    tabs: { requests: "Diagnostic requests", experts: "Experts", interventions: "Interventions" },
    stats: { diagnostics: "Requests", new: "New", experts: "Experts", examples: "incl. examples", interventions: "Interventions", revenue: "Invoiced excl. VAT", commission: "Commissions" },
    emailOn: "E-mail notifications active (ADMIN_NOTIFY_EMAIL).",
    emailOff: "ADMIN_NOTIFY_EMAIL not configured — requests are saved, e-mail sending is skipped.",
    h: { ref: "Ref.", date: "Date", company: "Company", contact: "Contact", vertical: "Vertical", need: "Need", urgency: "Urgency", status: "Status", email: "E-mail notif.", name: "Name", country: "Country", skills: "Skills", rate: "Rate", availability: "Avail.", example: "Example", actions: "Actions", expert: "Expert", client: "Client", duration: "Duration", amount: "Amount excl. VAT", commission: "Commission", pdf: "PDF" },
    emailStatus: { pending: "pending", sent: "sent", failed: "failed", skipped_no_recipient: "skipped" },
    del: "Delete",
    confirmDel: (n) => `Permanently delete expert ${n}?`,
    deleted: "Expert deleted.",
    updated: "Update saved.",
    empty: "Nothing here yet.",
    view: "Details",
  },
};

export const content = { fr, en };
